import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Publications from './components/Publications';
import Scholarships from './components/Scholarships';
import Congresses from './components/Congresses';
import Tasks from './components/Tasks';
import Users from './components/Users';
import Laboratories from './components/Laboratories';
import './App.css';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      // Fetch fresh user data from server to get role
      const fetchUser = async () => {
        try {
          const response = await fetch('/api/auth/me', {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          });
          if (response.ok) {
            const userData = await response.json();
            setUser(userData);
            localStorage.setItem('user', JSON.stringify(userData));
          } else {
            // Token is invalid, clear storage
            localStorage.removeItem('token');
            localStorage.removeItem('user');
          }
        } catch (error) {
          console.error('Error fetching user:', error);
        } finally {
          setLoading(false);
        }
      };
      fetchUser();
    } else {
      setLoading(false);
    }
  }, []);

  const handleLogin = (userData, token) => {
    console.log('User logged in:', userData); // Debug log
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route
            path="/login"
            element={user ? <Navigate to={user.role === 'superadmin' ? "/laboratories" : (user.role === 'director' ? "/users" : "/dashboard")} /> : <Login onLogin={handleLogin} />}
          />
          
          {/* Superadmin-only routes: Laboratories and Users */}
          {user && user.role === 'superadmin' ? (
            <>
              <Route path="/laboratories" element={<Laboratories user={user} onLogout={handleLogout} />} />
              <Route path="/users" element={<Users user={user} onLogout={handleLogout} />} />
              <Route path="*" element={<Navigate to="/laboratories" />} />
            </>
          ) : user && user.role === 'director' ? (
            <>
              {/* Director routes: Users (their lab only), Dashboard, Publications, Scholarships, Congresses, Tasks */}
              <Route path="/users" element={<Users user={user} onLogout={handleLogout} />} />
              <Route path="/dashboard" element={<Dashboard user={user} onLogout={handleLogout} />} />
              <Route path="/publications" element={<Publications user={user} onLogout={handleLogout} />} />
              <Route path="/scholarships" element={<Scholarships user={user} onLogout={handleLogout} />} />
              <Route path="/congresses" element={<Congresses user={user} onLogout={handleLogout} />} />
              <Route path="/tasks" element={<Tasks user={user} onLogout={handleLogout} />} />
              <Route path="*" element={<Navigate to="/users" />} />
            </>
          ) : user ? (
            <>
              {/* Member routes: Dashboard, Publications, Scholarships, Congresses, Tasks (no Users access) */}
              <Route path="/dashboard" element={<Dashboard user={user} onLogout={handleLogout} />} />
              <Route path="/publications" element={<Publications user={user} onLogout={handleLogout} />} />
              <Route path="/scholarships" element={<Scholarships user={user} onLogout={handleLogout} />} />
              <Route path="/congresses" element={<Congresses user={user} onLogout={handleLogout} />} />
              <Route path="/tasks" element={<Tasks user={user} onLogout={handleLogout} />} />
              <Route path="*" element={<Navigate to="/dashboard" />} />
            </>
          ) : (
            <>
              <Route path="*" element={<Navigate to="/login" />} />
            </>
          )}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
